import { api } from "api/api";

export enum CONFIG_OPTION_TYPES {
    BANNER_URL = "BannerUrl",
    MAP_URL = "MapUrl",
    NAME = "Name",
    ADDRESS = "Address",
    REDIRECT_URL = "RedirectUrl",
    REDIRECT_ON_CLICK = "RedirectOnClick",
    DESCRIPTION = "Description",
    OPTION = "Option",
    AGREEMENT_CONSENT = "AgreementConsent",
    PERSONAL_DATA_CONSENT = "PersonalDataConsent",
    MARKETING_CONSENT = "MarketingConsent",
}

export default async function getConfigOption(option: CONFIG_OPTION_TYPES[]) {
    const url = `api/public/book/appointment/online/config/option`;

    const response =  await api.get(url, {
        params: { option }
    });

    return response.data;
};
